// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"240":"c36f3faa","592":"c15bf2b0"}[chunkId] || chunkId) + "." + {"240":"66a54ba2a213f84b","580":"59f5546b715b80bf","592":"e0a406d1b43822b3","605":"5f3bbbff9dd30c7d"}[chunkId] + ".js";
};